import React from "react"
import Link from "gatsby-link"
import * as styles from "./pagination.module.scss"

const Pagination = () => {
  return (
    <ul className={styles.pagination}>
      <li>
        <Link to="/modules">Zurück zur Übersicht</Link>
      </li>
    </ul>
  )
}

export default Pagination
